export default "__VITE_ASSET__CMyWhdvD__"